/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';


// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getDevelopers } from '../../../db/DeveloperRequestHandler';
import store from '../../../components/stores/Store';

import {
  getDeveloperUsers,
  addDeveloperUser,
} from '../../../db/DeveloperRequestHandler';
import { getIfFuncAuthorized } from '../../../utils/CheckSomething';
import CheckHandler from '../../../utils/CheckHandler';
import ITextField from '../../../components/UI/ITextField';

const styles = {
  root: {},
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    minWidth: '20ch',
  },
  rootform: {
    textAlign: 'left',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};
// NavigateLeft
class SelectionOfDeveloperUserManagementInner extends Component {
  constructor() {
    super();
    store.clearTableConfig();
    store.setSelections({
      developerID: '',
      userName: '',  // 销售姓名
      phoneNumber: '', // 销售手机号
    });
    this.state = {
      addDeveloperUserDialogOpen: false,
      addDeveloperUserParams: {
        developerID: '',
        name: '',
        mobileNumber: '',
      },
      dialogMsg: '',
    };
    this.addDeveloperUser = this.addDeveloperUser.bind(this);
    this.onAddDeveloperUserDialogChange = this.onAddDeveloperUserDialogChange.bind(this);

    this.search = this.search.bind(this);
    this.addDeveloperUser = this.addDeveloperUser.bind(this);
    // this.updateDeveloperUser = this.updateDeveloperUser.bind(this);
    // this.deleteDeveloperUser = this.deleteDeveloperUser.bind(this);
  }

  async componentDidMount() {
    this.getDevelopers();
    this.search();
    store.search = this.search;
    store.clearLinesSelected();
  }

  async getDevelopers() {
    console.log(`----- send req of  getDevelopers`);
    const rst = await getDevelopers({});
    console.log(`----- rst of getDevelopers: `, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '房产商查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setDeveloperTable(rst.data);
      return true;
    }
  }

  componentWillUnmount() { }



  async addDeveloperUser() {
    const developerID = this.state.addDeveloperUserParams.developerID.trim();
    const name = this.state.addDeveloperUserParams.name.trim();
    const mobileNumber = this.state.addDeveloperUserParams.mobileNumber.trim();

    const chkRst = CheckHandler.checkParams([
      { key: '房产商名称', value: developerID, notNull: true, type: '', minLength: 36, maxLength: 36 },
      { key: '姓名', value: name, notNull: true, type: '', maxLength: 16 },
      { key: '手机号', value: mobileNumber, notNull: true, type: 'phone', maxLength: 11 },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    console.log(`----- send req of  addDeveloperUser: `, this.state.addDeveloperUserParams);
    const rst = await addDeveloperUser({
      developerId: developerID,
      userName: name,
      phoneNumber: mobileNumber,
    });
    console.log(`----- rst of addDeveloperUser: `, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '系统错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || '添加成功');
      this.setState({
        addDeveloperUserDialogOpen: false,
        addDeveloperUserParams: {}
      });
      this.search();
      return true;
    }
    return;
  }

  async search() {
    if (!getIfFuncAuthorized('房票管理-开发商用户管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    store.clearLinesSelected();
    const selections = {
      developerId: ['equal', store.selections.developerID],
      userName: ['like', store.selections.userName],
      phoneNumber: ['like', store.selections.phoneNumber],
    };
    console.log('----- 搜索：', selections);
    const rst = await getDeveloperUsers({
      where: selections,
      order: store.tableConfig.order || 'desc',
      orderBy: store.tableConfig.orderBy || 'createdate',
      currentPage: store.tableConfig.currentPage, // 当前页
      rowsPerPage: store.tableConfig.rowsPerPage, // 每页条数
    });

    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setTable(rst.data);
      return true;
    }
  }



  onAddDeveloperUserDialogChange(e, prop) {
    e.stopPropagation();
    const newAddDeveloperUserParams = this.state.addDeveloperUserParams;
    newAddDeveloperUserParams[prop] = e.target.value;
    this.setState({ addDeveloperUserParams: newAddDeveloperUserParams });
  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {(getIfFuncAuthorized('房票管理-开发商用户管理-添加')) && (
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={e => this.setState({ addDeveloperUserDialogOpen: true })}
            >
              添加
            </Button>
          )}
        </form>
        <form className={classes.rootform} noValidate autoComplete="off">
          <TextField
            id="outlined-number"
            label="账号(手机号)"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.phoneNumber || ''}
            onChange={e => store.onChangeSelection(e, 'phoneNumber')}
          />
          <TextField
            id="outlined-number"
            label="姓名"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.userName || ''}
            onChange={e => store.onChangeSelection(e, 'userName')}
          />
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel
              id="demo-simple-select-outlined-label"
              style={{ marginTop: '-8px' }}
            >
              所属开发商
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="开发商"
              value={store.selections.developerID || ''}
              onChange={e => store.onChangeSelection(e, 'developerID')}
              margin="dense"
            >
              <MenuItem value="">
                <em>请选择</em>
              </MenuItem>
              {
                store.developerTable.map(
                  (row, index) => {
                    const ID = row.ID;
                    const name = row.name;
                    return (<MenuItem value={ID} key={ID}>{name}</MenuItem>);
                  }
                )
              }
            </Select>
          </FormControl>

          <Button
            color="primary"
            variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >
            搜索
          </Button>
          <Button
            color="primary"
            variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={store.clearSelection}
          >
            清除搜索
          </Button>
        </form>

        <Dialog
          open={this.state.addDeveloperUserDialogOpen}
          onClose={e => this.setState({ addDeveloperUserDialogOpen: false, addDeveloperUserParams: {} })} aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            id="form-dialog-title"
            style={{ width: '300px' }}
          >
            添加开发商用户
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel
                id="demo-simple-select-outlined-label"
                style={{ marginTop: '-8px' }}
              >
                房产商名称
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.addDeveloperUserParams.developerID || ''}
                onChange={e => this.onAddDeveloperUserDialogChange(e, 'developerID')}
                label="房产商名称"
                margin="dense"
              >
                <MenuItem value="">
                  <em>请选择</em>
                </MenuItem>
                {
                  store.developerTable.map(
                    (row, index) => {
                      const ID = row.ID;
                      const name = row.name;
                      return (
                        <MenuItem value={ID} key={ID}>
                          {name}
                        </MenuItem>
                      );
                    }
                  )
                }
              </Select>
            </FormControl>
            <ITextField
              autoFocus
              margin="dense"
              id="mobileNumber"
              label="*手机号"
              fullWidth

              ivalue={this.state.addDeveloperUserParams.mobileNumber || ''}
              onChange={e => this.onAddDeveloperUserDialogChange(e, 'mobileNumber')}
              type="phone"
              maxLength='11'
              notNull
            />
            <ITextField
              margin="dense"
              id="name"
              label="*姓名"
              fullWidth

              ivalue={this.state.addDeveloperUserParams.name || ''}
              onChange={e => this.onAddDeveloperUserDialogChange(e, 'name')}
              type=""
              minLength='2'
              maxLength='16'
              notNull
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.addDeveloperUser}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认添加
            </Button>
            <Button
              onClick={e => this.setState({ addDeveloperUserDialogOpen: false, addDeveloperUserParams: {} })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionOfDeveloperUserManagement = observer(SelectionOfDeveloperUserManagementInner);

SelectionOfDeveloperUserManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfDeveloperUserManagement);
